module.exports = __webpack_public_path__ + "media/images/plans/plan-detail-icon-hairmake-717f9dbe1b75a16f61bfe46b5bd5d980.png";